module.exports = __webpack_public_path__ + "img/app_store_dark.2928664.svg";